import {CittadinoMensaStudenteDTO} from '../../../../core/api/generated';
import {Studente} from '../../../../shared/interfaces/studente-figlio.interface';

/**
 * Adatta una riga della discovery leggera (`CittadinoMensaStudenteDTO`) alla shape `Studente`
 * consumata dai consumatori "pesanti" (command palette, choose-child-modal): id/nome/cognome,
 * `tipoPagamento` (da `servizio.tipo_pagamento`, gate visibilità pagamenti), `portafogli.residuo`
 * (importo suggerito).
 *
 * TRAPPOLA snake/camel: il DTO discovery espone `is_sospeso`/`is_esente` (snake_case) mentre
 * la logica palette legge `isSospeso`/`isEsente` (camelCase, es. `getSospesoKey`). La traduzione
 * è confinata QUI: un cast diretto romperebbe silenziosamente il gate sospensione. `scuola` e
 * `portafogli` sono tipi condivisi tra i due DTO → passthrough invariato. Lo stato
 * `gestione_manuale` (gate ATTIVA) NON è nella discovery: lo carica async la palette via
 * `getConfigurazione1` al momento della validazione del pagamento.
 *
 * Mappa solo i campi effettivamente consumati: lo `Studente` risultante è volutamente parziale.
 */
export function mapDiscoveryToStudente(dto: CittadinoMensaStudenteDTO): Studente {
  return {
    id: dto.id,
    nome: dto.nome,
    cognome: dto.cognome,
    scuola: dto.scuola,
    portafogli: dto.portafogli,
    isSospeso: dto.is_sospeso,
    isEsente: dto.is_esente,
    tipoPagamento: dto.servizio?.tipo_pagamento,
    isPresenteRicaricaDaPagare: dto.pagamenti?.is_presente_ricarica_da_pagare,
  };
}
